// const notes = [{
//    key: 1,
//    content: "Pursuing a Master of Computer Applications at the University of Chhattisgarh, India, with a focus on Entrepreneurship and Innovation. Completed Bachelor's degree in Computer Science, with a strong foundation in software development and a deep interest in technology."
// }
// ]
// export default notes;


// const notes = [{
//    key: 1,
//    content: "Completed a Master of Computer Applications (MCA) from the University of Chhattisgarh, India, with a focus on Entrepreneurship and Innovation. Skilled in software development, full-stack web technologies, and mobile app development, with a strong interest in building scalable and innovative solutions."
// }]

// export default notes;



const notes = [{
   key: 1,
   content: "Completed a Master of Computer Applications from the University of Chhattisgarh, India, with a focus on Entrepreneurship and Innovation. Passionate about software development, with experience in full-stack web technologies and cross-platform application development, and a strong interest in building scalable and innovative solutions."
}]

export default notes;